import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { urlChecker } from './urlChecker';

import QRCodeGenerator from 'components/QRCodeGenerator';

import Slider from "react-slick";

import 'assets/css/slick.css';

const SimpleSlider = ({ objects, selectedIndex, handleClose }) => {

    const settings = {
        dots: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: selectedIndex,
        lazyLoad: true,
        swipeToSlide: true,
        infinite: false,
      };

      const handleKeyDown = (e) => {
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp' || e.key === 'Shift') {
          e.preventDefault();
          simulateButtonClick("prev");
        } else if (e.key === 'ArrowRight' || e.key === 'ArrowDown' || e.key === 'Tab') {
          e.preventDefault();
          simulateButtonClick("next");
        } else if (e.key === 'Escape') {
          handleClose();
        }
      };

      const simulateButtonClick = (direction) => {
        const button = document.querySelector(`.slick-arrow.slick-${direction}`);
        if (button) button.click();
      };

      useEffect(() => {
        window.addEventListener('keydown', handleKeyDown);

        return () => {
          window.removeEventListener('keydown', handleKeyDown);
        };
      }, []);

      const isUrl = urlChecker(objects[0]);

  return (
    <Slider {...settings} style={{ width: "75vw", zIndex: 1501 }}>
        {objects.map((imageUrl, index) => (
          isUrl ? (
            <img key={index} src={imageUrl} />
          ) : (
            <QRCodeGenerator key={index} url={imageUrl} />
          )
        ))}
    </Slider>
  );
};

SimpleSlider.propTypes = {
    objects: PropTypes.array,
    selectedIndex: PropTypes.number,
    handleClose: PropTypes.func
};

export default SimpleSlider;
